import {
  Component,
  OnInit,
  ChangeDetectorRef,
  TemplateRef,
  ViewChild,
  EventEmitter,
  Output,
} from "@angular/core";
import { NgbDateParserFormatter } from "@ng-bootstrap/ng-bootstrap";
import { UserService } from "../../../services/userService/user.service";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { DatePipe } from "@angular/common";
import * as moment from "moment";
import { ToastrService } from "ngx-toastr";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { environment } from "../../../../environments/environment";
import * as XLSX from "xlsx";
import { Subject } from "rxjs";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { Sort } from "@angular/material/sort";
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: "app-inquirylist",
  templateUrl: "./inquirylist.component.html",
  styleUrls: ["./inquirylist.component.css"],
})
export class InquirylistComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild("showimport") showimport: any;
  @Output() clearEvent = new EventEmitter<void>();
  displayedColumns: string[] = [
    "ProjectName",
    "InquiryName",
    "CustomerName",
    "BussinessVerticals",
    "Stage",
    "InquiryProbability",
    "QuotationEngineer",
    "SalesEngineer",
    "QuotedDate",
    "QuotedValue",
    "ReportedValue",
    "ExpOrderDate",
    "Action",
  ];

  sortData: any = { column: "CompanyName", direction: "asc" };
  data1: unknown[];
  showinquiry1: any = [];

  disableDate() {
    return false;
  }

  dtOptions: any = {};
  showinquiry: any = [];
  registerForm: FormGroup;
  showProjectArray: any = [];
  showInquiryArray: any = [];
  showCustomerArray: any = [];
  showStageArray: any = [];
  showProbabilityArray: any = [];
  showQuotationErArray: any = [];
  showSalesErArray: any = [];
  businessVerticalArray: any = [];
  dropdownSetting1: any = {};
  dropdownSetting2: any = {};
  dropdownSetting3: any = {};
  dropdownSetting8: any = {};
  dropdownSetting9: any = {};
  dropdownSetting10: any = {};
  dropdownSetting11: any = {};
  dropdownSetting12: any = {};
  activitytype: any = "activity";
  isCollapsed: any;
  date_range: any = { startDate: moment, endDate: moment };
  date_range2: any = { startDate2: moment, endDate2: moment };
  start_date: string;
  end_date: string;
  timezone: any;
  arrHeader: any = [];

  ranges: any = {
    Today: [moment(), moment()],
    Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
    "Last 7 Days": [moment().subtract(6, "days"), moment()],
    "Last 30 Days": [moment().subtract(29, "days"), moment()],
    "This Month": [moment().startOf("month"), moment().endOf("month")],
    "Last Month": [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ],
  };

  invalidDates: moment.Moment[] = [
    moment().add(2, "days"),
    moment().add(3, "days"),
    moment().add(5, "days"),
  ];

  isInvalidDate = (m: moment.Moment) => {
    return this.invalidDates.some((d) => d.isSame(m, "day"));
  };

  baseurl: string;
  permission: any;
  roleId: any;
  dataSource: MatTableDataSource<any>;
  TotalRecord: any;
  currentPage: any = 0;
  pageSize: any = 10;
  totalSize: any;
  showTable: boolean;
  searchword: any;
  type: string;
  namesort: string;
  upicon: boolean;
  downicon: boolean;
  columnsort: string;
  deleteId: any;
  delstatus: any;
  modalRef: BsModalRef;
  isValid: boolean;
  err_message: any;
  dropdownSettings: any = {};
  start: any = "";
  start2: any = "";
  end: any = "";
  end2: any = "";
  IqrName: any;
  IqrNum: any;
  isExcelFile: boolean;
  upfile: any;
  inputFile: any;
  data: unknown[];
  dataSheet = new Subject();
  count: number = 0;
  Totalrec: any;
  invalid: any;
  valid: number;
  dataarray: any;
  isCollapsed1: boolean = false;
  sampleInquiryExl: string;
  ran: any;

  constructor(
    public formatter: NgbDateParserFormatter,
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private router: Router,
    private UserService: UserService,
    private datePipe: DatePipe,
    private modalService: BsModalService,
    private spinner: NgxSpinnerService,
    private changeDetectorRefs: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.baseurl = environment.api_url;
    this.sampleInquiryExl = environment.import_sample + "Sample_Inquiry.xlsx";
    let permi = JSON.parse(localStorage.getItem("Permission"));
    this.permission = this.UserService.decryptData(permi);
    console.log(this.permission)
    let rId = localStorage.getItem("roleId");
    this.roleId = this.UserService.decryptData(rId);
    this.isCollapsed = false;

    this.date_range.startDate = "";
    this.date_range.endDate = "";
    this.date_range2.startDate2 = "";
    this.date_range2.endDate2 = "";
    this.date_range = null;
    this.date_range2 = null;
    this.getproject();
    this.getinquiry();
    this.getcustomer();
    this.getstage();
    this.getprobability();
    this.getquotationEr();
    this.getBusinessVertical();

    this.dropdownSetting1 = {
      singleSelection: false,
      text: "Project Name",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownSetting2 = {
      singleSelection: false,
      text: "Inquiry Name",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownSetting3 = {
      singleSelection: false,
      text: "Customer Name",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownSetting8 = {
      singleSelection: false,
      text: "Stages",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownSetting9 = {
      singleSelection: false,
      text: "Probability",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownSetting10 = {
      singleSelection: false,
      text: "Quotation Engineer",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownSetting11 = {
      singleSelection: false,
      text: "Sales Engineer",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownSetting12 = {
      singleSelection: false,
      text: "Business Verticals",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownSettings = {
      singleSelection: false,
      text: "Select",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      classes: "myclass custom-class",
      badgeShowLimit: "1",
    };

    this.registerForm = this.formBuilder.group({
      ProjectId: [""],
      Territory: [""],
      InquiryId: [""],
      InquiryName: [""],
      CustomerName: [""],
      MEPContractor: [""],
      MainContractor: [""],
      DesignConsultant: [""],
      SupervisionConsultant: [""],
      IsQuotedDate: [false],
      IsExpectedDate: [false],
      StageId: [""],
      InquiryProbability: [""],
      ReceivedDate: [""],
      QuotationEngineerId: [""],
      SalesEngineerId: [""],
      BusinessVertical: [""],
      QuotedValue: [""],
      ReportedValue: [""],
      QuotedDate: [""],
      IncoTerms: [""],
      Application: [""],
      ExpOrderDate: [""],
      LostTo: [""],
      Reason: [""],
      LOIMargin: [""],
      POMargin: [""],
      Revision: [""],
      RevisionNote: [""],
    });

    let data = {
      InquiryId: "",
      InquiryName: "",
      ProjectId: "",
      CustomerName: "",
      MEPContractor: "",
      MainContractor: "",
      DesignConsultant: "",
      SupervisionConsultant: "",
      StageId: "",
      QuotedStartDate: "",
      QuotedEndDate: "",
      ExpectedStartDate: "",
      ExpectedEndDate: "",
      InquiryProbability: "",
      ReceivedDate: "",
      QuotationEngineerId: "",
      SalesEngineerId: "",
      BusinessVertical: "",
      Status: "1, 2",
      SearchWord: this.searchword,
      Sort: "",
      SortWise: "",
      Export: "false",
      ItemPerPages: this.pageSize,
      PageNo: this.currentPage + 1,
    };
    this.spinner.show();
    this.UserService.InquiryListFilter(data).subscribe((response: any) => {
      if (response["result"] == "success") {
        this.spinner.hide();
        this.currentPage = 0;
        this.showinquiry = response["ContactList"];
        this.dataSource = new MatTableDataSource<any>(response["ContactList"]);
        this.dataSource.paginator = this.paginator;
        this.TotalRecord = response["TotalRecord"];
        this.totalSize = response["TotalRecord"];
        this.iterator();
      } else if (response["result"] == "Failed") {
        this.toastr.error(response["Msg"]);
        this.spinner.hide();
      } else {
        this.toastr.error(response['Msg'] || response['Message']);
        this.spinner.hide();
      }
    });
  }

  showProject: any = [];
  getproject() {
    let data = {};
    this.UserService.GetAllProject(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.showProjectArray = res;
        this.showProject = [];
        for (const projectData of this.showProjectArray["Data"]) {
          this.showProject.push({
            id: projectData["ProjectId"],
            itemName: `${projectData["ProjectName"]} (${projectData["ProjectNumber"]})`,
          });
        }
      } else {
        this.showProjectArray = [];
      }
    });
  }
  selectedproject: any = [];
  selectedProject: any;
  selectedProjectId: any = "";
  onProjectSelect(item: any) {
    this.selectedProject = "";
    this.selectedProjectId = "";
    this.selectedproject.forEach((element) => {
      this.selectedProject += element["itemName"] + ", ";
      this.selectedProjectId += element["id"] + ", ";
    });
  }

  showInquiry: any = [];
  getinquiry() {
    let data = {};
    this.UserService.GetInquiryNumber(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.showInquiryArray = res;
        this.showInquiry = [];
        for (const inquiryData of this.showInquiryArray["Data"]) {
          this.showInquiry.push({
            id: inquiryData["InquiryId"],
            itemName: `${inquiryData["InquiryName"]} (${inquiryData["InquiryNumber"]})`,
          });
        }
      } else {
        this.showInquiryArray = [];
      }
    });
  }
  selectedinquiry: any = [];
  selectedInquiry: any;
  selectedInquiryId: any = "";
  onInquirySelect(item: any) {
    this.selectedInquiry = "";
    this.selectedInquiryId = "";
    this.selectedinquiry.forEach((element) => {
      this.selectedInquiry += element["itemName"] + ", ";
      this.selectedInquiryId += element["id"] + ", ";
    });
  }

  showQuotationEr: any = [];
  showSalesEr: any = [];
  getquotationEr() {
    let data = {};
    this.UserService.GetAllUser(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.showQuotationErArray = res;
        this.showQuotationEr = [];
        for (const quotationErData of this.showQuotationErArray["Data"]) {
          this.showQuotationEr.push({
            id: quotationErData["UserId"],
            itemName: `${quotationErData["UserName"]} (${quotationErData["EmailId"]}) ${quotationErData["EmployeeId"]}`,
          });
        }

        this.showSalesErArray = res;
        this.showSalesEr = [];
        for (const salesErData of this.showSalesErArray["Data"]) {
          this.showSalesEr.push({
            id: salesErData["UserId"],
            itemName: `${salesErData["UserName"]} (${salesErData["EmailId"]}) ${salesErData["EmployeeId"]}`,
          });
        }
      } else {
        this.showQuotationErArray = [];
        this.showSalesErArray = [];
      }
    });
  }
  selectedquotationEr: any = [];
  selectedQuotationEr: any;
  selectedQuotationErId: any = "";
  onQuotationErSelect(item: any) {
    this.selectedQuotationEr = "";
    this.selectedQuotationErId = "";
    this.selectedquotationEr.forEach((element) => {
      this.selectedQuotationEr += element["itemName"] + ", ";
      this.selectedQuotationErId += element["id"] + ", ";
    });
  }

  selectedsalesEr: any = [];
  selectedSalesEr: any;
  selectedSalesErId: any = "";
  onSalesErSelect(item: any) {
    this.selectedSalesEr = "";
    this.selectedSalesErId = "";
    this.selectedsalesEr.forEach((element) => {
      this.selectedSalesEr += element["itemName"] + ", ";
      this.selectedSalesErId += element["id"] + ", ";
    });
  }

  businessVertical: any = [];
  getBusinessVertical() {
    let data = {};
    this.UserService.GetBusinessVertical(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.businessVerticalArray = res;
        this.businessVertical = [];
        for (const verticalData of this.businessVerticalArray["Data"]) {
          this.businessVertical.push({
            id: verticalData["Id"],
            itemName: verticalData["Name"],
          });
        }
      } else {
        this.businessVerticalArray = [];
      }
    });
  }
  selectedBusiness: any = [];
  selectedBusinessName: string = "";
  selectedBusinessNameId: any = "";
  onBusinessSelect(item: any) {
    this.selectedBusinessName = "";
    this.selectedBusinessNameId = "";
    this.selectedBusiness.forEach((element) => {
      this.selectedBusinessName += element["itemName"] + ", ";
      this.selectedBusinessNameId += element["id"] + ", ";
    });
  }

  showStage: any = [];
  getstage() {
    let data = {};
    this.UserService.GetStageList(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.showStageArray = res;
        this.showStage = [];
        for (const stageData of this.showStageArray["Data"]) {
          this.showStage.push({
            id: stageData["StageId"],
            itemName: stageData["StageName"],
          });
        }
      } else {
        this.showStageArray = [];
      }
    });
  }
  selectedstage: any = [];
  selectedStage: any;
  selectedStageId: any = "";
  onStageSelect(item: any) {
    this.selectedStage = "";
    this.selectedStageId = "";
    this.selectedstage.forEach((element) => {
      this.selectedStage += element["itemName"] + ", ";
      this.selectedStageId += element["id"] + ", ";
    });
  }

  showProbability: any = [];
  getprobability() {
    let data = {};
    this.UserService.GetInquiryProbabilityList(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.showProbabilityArray = res;
        this.showProbability = [];
        for (const probabilityData of this.showProbabilityArray["Data"]) {
          this.showProbability.push({
            id: probabilityData["InquiryProbabilityId"],
            itemName: probabilityData["Percentage"],
          });
        }
      } else {
        this.showProbabilityArray = [];
      }
    });
  }
  selectedprobability: any = [];
  selectedProbability: any;
  selectedProbabilityId: any = "";
  onProbabilitySelect(item: any) {
    this.selectedProbability = "";
    this.selectedProbabilityId = "";
    this.selectedprobability.forEach((element) => {
      this.selectedProbability += element["itemName"] + ", ";
      this.selectedProbabilityId += element["id"] + ", ";
    });
  }

  showCustomer: any = [];
  getcustomer() {
    let data = {};
    this.UserService.GetAllCustomer(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.showCustomerArray = res;
        this.showCustomer = [];
        for (const customer of this.showCustomerArray["CustomerName"]) {
          this.showCustomer.push({
            id: customer["CompanyId"],
            itemName: customer["CompanyName"],
          });
        }
      } else {
        this.showCustomerArray = [];
      }
    });
  }
  selectedcustomer: any = [];
  selectedCustomer: any;
  selectedCustomerId: any = "";
  onCustomerSelect(item: any) {
    this.selectedCustomer = "";
    this.selectedCustomerId = "";
    this.selectedcustomer.forEach((element) => {
      this.selectedCustomer += element["itemName"] + ", ";
      this.selectedCustomerId += element["id"] + ", ";
    });
  }

  onSelectAll(items: any) {}
  onDeSelectAll(items: any) {}

  openClosefun() {
    this.isCollapsed = !this.isCollapsed;
  }

  openClosefun1() {
    this.isCollapsed1 = !this.isCollapsed1;
  }

  changeActivityType(type) {
    this.activitytype = type;
  }

  dateChangeFun() {
    if (this.date_range && this.date_range != undefined) {
      if (this.date_range.startDate != null) {
        this.start_date = this.datePipe.transform(
          this.date_range.startDate.tz(this.timezone)._d,
          "yyyy-MM-dd"
        );
        this.end_date = this.datePipe.transform(
          this.date_range.endDate.tz(this.timezone)._d,
          "yyyy-MM-dd"
        );
        this.start_date = moment(this.start_date, "YYYY-MM-DD")
          .utc()
          .format("YYYY-MM-DD");
        this.end_date = moment(this.end_date, "YYYY-MM-DD")
          .utc()
          .format("YYYY-MM-DD");
      } else {
        this.start_date = "";
      }
    }
  }

  tr: any;
  date: any;
  onSubmit() {
    this.showTable = false;
    this.currentPage = 0;
    this.spinner.show();
    if (this.registerForm.value.IsQuotedDate) {
      if (
        this.date_range.startDate &&
        this.date_range.startDate != "" &&
        this.date_range.endDate &&
        this.date_range.endDate != ""
      ) {
        this.start = this.datePipe.transform(
          this.date_range.startDate,
          "yyyy-MM-dd"
        );
        this.end = this.datePipe.transform(
          this.date_range.endDate,
          "yyyy-MM-dd"
        );
      } else {
        this.start = "";
        this.end = "";
      }
    } else {
      this.start = "";
      this.end = "";
    }
    if (this.registerForm.value.IsExpectedDate) {
      if (
        this.date_range2.startDate &&
        this.date_range2.startDate != "" &&
        this.date_range2.endDate &&
        this.date_range2.endDate != ""
      ) {
        this.start2 = this.datePipe.transform(
          this.date_range2.startDate,
          "yyyy-MM-dd"
        );
        this.end2 = this.datePipe.transform(
          this.date_range2.endDate,
          "yyyy-MM-dd"
        );
      } else {
        this.start2 = "";
        this.end2 = "";
      }
    } else {
      this.start2 = "";
      this.end2 = "";
    }
    let data = {
      InquiryId: this.selectedInquiryId,
      ProjectId: this.selectedProjectId,
      CustomerName: this.selectedCustomerId,
      Stages: this.selectedStageId,
      Probability: this.selectedProbabilityId,
      QuotationEngineer: this.selectedQuotationErId,
      SalesEngineer: this.selectedSalesErId,
      BusinessVertical: this.selectedBusinessNameId,
      QuotedStartDate: this.start,
      QuotedEndDate: this.end,
      IsQuotedDate: this.registerForm.value.IsQuotedDate,
      IsExpectedDate: this.registerForm.value.IsExpectedDate,
      ExpectedStartDate: this.start2,
      ExpectedEndDate: this.end2,
      ItemPerPages: this.pageSize,
      PageNo: this.currentPage + 1,
      SearchWord: this.searchword,
      Sort: this.namesort,
      SortWise: this.type,
      Export: "false",
      Status: "1, 2",
    };
    this.spinner.show();
    this.UserService.InquiryListFilter(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.spinner.hide();
        this.showTable = true;
        this.showinquiry = res["ContactList"];
        this.dataSource = new MatTableDataSource<any>(res["ContactList"]);
        this.TotalRecord = res["TotalRecord"];
        this.tr = res["TotalRecord"];
        this.totalSize = this.TotalRecord;
        this.router.navigate(["/inquiry/inquirylist"]);
      } else if (res["result"] == "Failed") {
        this.toastr.error(res["Msg"]);
        this.spinner.hide();
      } else {
        this.toastr.error(res['Msg'] || res['Message']);
        this.spinner.hide();
      }
    });
  }

  resetData() {
    this.selectedInquiryId = "";
    this.selectedProjectId = "";
    this.selectedCustomerId = "";
    this.selectedStageId = "";
    this.selectedProbabilityId = "";
    this.selectedQuotationErId = "";
    this.selectedSalesErId = "";
    this.selectedBusinessNameId = "";
    this.start = "";
    this.end = "";
    this.start2 = "";
    this.end2 = "";
    this.registerForm.reset();
    this.totalSize = this.tr;
    this.ngOnInit();
    this.isCollapsed = true;
  }

  clearStartDate() {
    this.date_range = null;
  }

  clearEndDate() {
    this.date_range2 = null;
  }

  public handlePage(e: any) {
    this.spinner.show();
    this.currentPage = e.pageIndex;
    this.pageSize = e.pageSize;
    this.iterator();
    let data = {
      InquiryId: this.selectedInquiryId,
      ProjectId: this.selectedProjectId,
      CustomerName: this.selectedCustomerId,
      Stages: this.selectedStageId,
      Probability: this.selectedProbabilityId,
      QuotationEngineer: this.selectedQuotationErId,
      SalesEngineer: this.selectedSalesErId,
      BusinessVertical: this.selectedBusinessNameId,
      QuotedStartDate: this.start,
      QuotedEndDate: this.end,
      IsQuotedDate: this.registerForm.value.IsQuotedDate,
      IsExpectedDate: this.registerForm.value.IsExpectedDate,
      ExpectedStartDate: this.start2,
      ExpectedEndDate: this.end2,
      ItemPerPages: this.pageSize,
      PageNo: this.currentPage + 1,
      SearchWord: this.searchword,
      Sort: this.namesort,
      SortWise: this.type,
      Export: "false",
      Status: "1, 2",
    };
    this.UserService.InquiryListFilter(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.TotalRecord = res["TotalRecord"];
        this.totalSize = this.TotalRecord;
        this.spinner.hide();
        this.dataSource = new MatTableDataSource<any>(res["ContactList"]);
      } else if (res["result"] == "Failed") {
        this.toastr.error(res["Msg"]);
        this.spinner.hide();
      } else {
        this.toastr.error(res['Msg'] || res['Message']);
        this.spinner.hide();
      }
    });
  }

  private iterator() {
    const end = (this.currentPage + 1) * this.pageSize;
    const start = this.currentPage * this.pageSize;
    const part = this.showinquiry.slice(start, end);
    this.dataSource = part;
  }

  view(eid) {
    if (this.permission.Inquiry_View == 1 || this.roleId == 1) {
      localStorage.setItem("activeId", "t9");
      let encryptid = this.UserService.encryptData(eid);
      encryptid = encryptid
        .toString()
        .replace("=", "Ar1t")
        .replace("/", "FGH")
        .replace("+", "THD");
      this.router.navigate(["/inquiry/detailinquiry", encryptid]);
    } else {
      this.toastr.error("Permission Denied !");
    }
  }

  applyFilter() {
    this.currentPage = 0;
    this.spinner.show();
    let data = {
      InquiryId: this.selectedInquiryId,
      ProjectId: this.selectedProjectId,
      CustomerName: this.selectedCustomerId,
      Stages: this.selectedStageId,
      Probability: this.selectedProbabilityId,
      QuotationEngineer: this.selectedQuotationErId,
      SalesEngineer: this.selectedSalesErId,
      BusinessVertical: this.selectedBusinessNameId,
      QuotedStartDate: this.start,
      QuotedEndDate: this.end,
      IsQuotedDate: this.registerForm.value.IsQuotedDate,
      IsExpectedDate: this.registerForm.value.IsExpectedDate,
      ExpectedStartDate: this.start2,
      ExpectedEndDate: this.end2,
      ItemPerPages: this.pageSize,
      PageNo: this.currentPage + 1,
      SearchWord: this.searchword,
      Sort: this.namesort,
      SortWise: this.type,
      Export: "false",
      Status: "1, 2",
    };
    this.UserService.InquiryListFilter(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.TotalRecord = res["TotalRecord"];
        this.totalSize = this.TotalRecord;
        this.spinner.hide();
        this.dataSource = new MatTableDataSource<any>(res["ContactList"]);
      } else if (res["result"] == "Failed") {
        this.toastr.error(res["Msg"]);
        this.spinner.hide();
      } else {
        this.toastr.error(res['Msg'] || res['Message']);
        this.spinner.hide();
      }
    });
  }

  clearUserData() {
    const previousValue = this.searchword;
    this.searchword = "";
    if (
      previousValue &&
      previousValue.length > 0 &&
      previousValue !== this.searchword
    ) {
      this.clearEvent.emit();
    }
  }

  onSortData(sort: Sort) {
    this.currentPage = 0;
    this.spinner.show();
    this.changeDetectorRefs.detectChanges();
    this.sortData = [];
    this.sortData = { column: sort.active, direction: sort.direction };
    this.type = sort.direction;
    this.namesort = sort.active;
    if (sort.direction == "asc") {
      this.upicon = true;
      this.downicon = false;
    } else {
      this.upicon = false;
      this.downicon = true;
    }
    this.columnsort = sort.active;

    let data = {
      InquiryId: this.selectedInquiryId,
      ProjectId: this.selectedProjectId,
      CustomerName: this.selectedCustomerId,
      Stages: this.selectedStageId,
      Probability: this.selectedProbabilityId,
      QuotationEngineer: this.selectedQuotationErId,
      SalesEngineer: this.selectedSalesErId,
      BusinessVertical: this.selectedBusinessNameId,
      QuotedStartDate: this.start,
      QuotedEndDate: this.end,
      IsQuotedDate: this.registerForm.value.IsQuotedDate,
      IsExpectedDate: this.registerForm.value.IsExpectedDate,
      ExpectedStartDate: this.start2,
      ExpectedEndDate: this.end2,
      ItemPerPages: this.pageSize,
      PageNo: this.currentPage + 1,
      SearchWord: this.searchword,
      Sort: this.namesort,
      SortWise: this.type,
      Export: "false",
      Status: "1, 2",
    };
    this.UserService.InquiryListFilter(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.TotalRecord = res["TotalRecord"];
        this.totalSize = this.TotalRecord;
        this.spinner.hide();
        this.dataSource = new MatTableDataSource<any>(res["ContactList"]);
      } else if (res["result"] == "Failed") {
        this.toastr.error(res["Msg"]);
        this.spinner.hide();
      } else {
        this.toastr.error(res['Msg'] || res['Message']);
        this.spinner.hide();
      }
    });
  }

  ExportOpenModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {
      class: "modal-sm modal-dialog-centered",
      backdrop: "static",
      ignoreBackdropClick: true,
      keyboard: false,
    });
  }

  exportConfirm() {
    this.exportinquiry();
    this.modalRef.hide();
  }

  exportinquiry() {
    this.showTable = false;
    this.spinner.show();

    if (this.registerForm.value.IsQuotedDate) {
      if (
        this.date_range.startDate &&
        this.date_range.startDate != "" &&
        this.date_range.endDate &&
        this.date_range.endDate != ""
      ) {
        this.start = this.datePipe.transform(
          this.date_range.startDate,
          "yyyy-MM-dd"
        );
        this.end = this.datePipe.transform(
          this.date_range.endDate,
          "yyyy-MM-dd"
        );
      }
    }
    if (this.registerForm.value.IsExpectedDate) {
      if (
        this.date_range2.startDate &&
        this.date_range2.startDate != "" &&
        this.date_range2.endDate &&
        this.date_range2.endDate != ""
      ) {
        this.start2 = this.datePipe.transform(
          this.date_range2.startDate,
          "yyyy-MM-dd"
        );
        this.end2 = this.datePipe.transform(
          this.date_range2.endDate,
          "yyyy-MM-dd"
        );
      }
    }
    let data = {
      InquiryId: this.selectedInquiryId,
      ProjectId: this.selectedProjectId,
      CustomerName: this.selectedCustomerId,
      StageId: this.selectedStageId,
      InquiryProbability: this.selectedProbabilityId,
      QuotationEngineerId: this.selectedQuotationErId,
      SalesEngineerId: this.selectedSalesErId,
      BusinessVertical: this.selectedBusinessNameId,
      QuotedStartDate: this.start,
      QuotedEndDate: this.end,
      ExpectedStartDate: this.start2,
      ExpectedEndDate: this.end2,
      ItemPerPages: this.pageSize,
      PageNo: this.currentPage + 1,
      SearchWord: this.searchword,
      Sort: this.namesort,
      SortWise: this.type,
      Export: "true",
      Status: "1, 2",
    };
    this.spinner.show();
    this.UserService.InquiryListFilter(data).subscribe((res: any) => {
      if (res["result"] == "success") {
        this.spinner.hide();
        let exporturl = res["Data"];
        window.open(this.baseurl + "/" + exporturl);
      } else if (res["result"] == "Failed") {
        this.toastr.error(res["Msg"]);
        this.spinner.hide();
      } else {
        this.toastr.error(res['Msg'] || res['Message']);
        this.spinner.hide();
      }
    });
  }

  onChange(evt) {
    let data, header;
    const target: DataTransfer = <DataTransfer>evt.target;
    const matchResult = /(.xls|.xlsx)/.exec(target.files[0].name);
    this.isExcelFile = !!matchResult;
    if (!this.isExcelFile) {
      this.toastr.error("Invaild File Format. Only xlsx Files Are Allowed !");
      return;
    }
    this.upfile = target.files[0];
    if (target.files.length > 1) {
      this.inputFile.nativeElement.value = "";
    }
    if (this.isExcelFile) {
      const reader: FileReader = new FileReader();
      reader.onload = (e: any) => {
        /* read workbook */
        const bstr: string = e.target.result;
        const wb: XLSX.WorkBook = XLSX.read(bstr, { type: "binary" });

        /* grab first sheet */
        const wsname: string = wb.SheetNames[0];
        const ws: XLSX.WorkSheet = wb.Sheets[wsname];

        /* for header */
        let arrHeaderMain = wb["Sheets"][wsname];
        this.arrHeader = [];
        if (arrHeaderMain == undefined || arrHeaderMain == null) {
          this.count = 0;
        } else {
          this.arrHeader.push(arrHeaderMain.A1?.h);
          this.arrHeader.push(arrHeaderMain.B1?.h);
          this.arrHeader.push(arrHeaderMain.C1?.h);
          this.arrHeader.push(arrHeaderMain.D1?.h);
          this.arrHeader.push(arrHeaderMain.E1?.h);
          this.arrHeader.push(arrHeaderMain.F1?.h);
          this.arrHeader.push(arrHeaderMain.G1?.h);
          this.arrHeader.push(arrHeaderMain.H1?.h);
          this.arrHeader.push(arrHeaderMain.I1?.h);
          this.arrHeader.push(arrHeaderMain.J1?.h);
          this.arrHeader.push(arrHeaderMain.K1?.h);
          this.arrHeader.push(arrHeaderMain.L1?.h);
          this.arrHeader.push(arrHeaderMain.M1?.h);
          this.arrHeader.push(arrHeaderMain.N1?.h);
          this.arrHeader.push(arrHeaderMain.O1?.h);
        }

        /* save data */
        this.data = XLSX.utils.sheet_to_json(ws, { raw: true });
      };

      reader.readAsBinaryString(target.files[0]);

      reader.onloadend = (e) => {
        this.showinquiry1 = Object.keys(this.data);
        this.dataSheet.next(this.data);

        let arr = [
          "ProjectName",
          "ProjectSource",
          "Territory",
          "InquiryName",
          "CustomerName",
          "MEPContractor",
          "MainContractor",
          "DesignConsultant",
          "SupervisionConsultant",
          "Stage",
          "InquiryProbability",
          "ReceivedDate",
          "QuotationEngineer",
          "SalesEngineer",
          "BusinessVertical",
        ];

        if (
          JSON.stringify(this.arrHeader) === JSON.stringify(arr) &&
          this.arrHeader.length > 0
        ) {
          if (this.showinquiry1.length > 0) {
            if (this.showinquiry1.length <= 1000) {
              this.count = 2;
            } else {
              this.count = 3;
            }
          } else {
            this.count = 1;
          }
        } else {
          this.count = 0;
        }
      };
    } else {
      this.inputFile.nativeElement.value = "";
    }
  }

  import() {
    if (this.data == undefined) {
      this.toastr.error("Please Select a valid xlsx file");
      return null;
    } else if (this.count == 0) {
      this.toastr.error("Invalid Template!");
      return;
    } else if (this.count == 1) {
      this.toastr.error("File should not be empty !");
      return;
    } else if (this.count == 3) {
      this.toastr.error("Maximum 1000 records are allowed !");
      return;
    } else {
      this.spinner.show();
      this.UserService.ImportInquiryList(this.data).subscribe(
        (res) => {
          if (res["result"] == "success") {
            this.spinner.hide();
            this.showimport.nativeElement.click();
            this.Totalrec = res["TotalRecord"];
            this.invalid = res["InvaildRow"];
            this.valid = this.Totalrec - this.invalid;
            this.dataarray = res["Data"];
            this.toastr.success(res["Msg"]);
          } else if (res["result"] == "Failed") {
            this.spinner.hide();
            this.showimport.nativeElement.click();
            this.Totalrec = res["TotalRecord"];
            this.invalid = res["InvaildRow"];
            this.valid = this.Totalrec - this.invalid;
            this.dataarray = res["Data"];
          } else {
            this.spinner.hide();
            this.toastr.error(res["Msg"]);
          }
        },
        (error) => {
          this.spinner.hide();
          this.Totalrec = 0;
          this.invalid = 0;
          this.valid = this.Totalrec - this.invalid;
        }
      );
    }
  }

  show(eid) {
    let encryptid = this.UserService.encryptData(eid);
    encryptid = encryptid
      .toString()
      .replace("=", "Ar1t")
      .replace("/", "FGH")
      .replace("+", "THD");
    this.router.navigate(["/inquiry/detailinquiry-editproduct/", encryptid]);
  }

  edit(id) {
    localStorage.setItem("active_id", "tab-selectbyid1");
    let encryptid = this.UserService.encryptData(id);
    encryptid = encryptid
      .toString()
      .replace("=", "Ar1t")
      .replace("/", "FGH")
      .replace("+", "THD");
    this.router.navigate(["/inquiry/editinquiry", encryptid]);
  }

  deleteOpenModal(template: TemplateRef<any>, name, data, num, id) {
    if (data) {
      this.deleteId = data;
      this.IqrName = name;
      this.IqrNum = num;
      this.delstatus = id;
      this.modalRef = this.modalService.show(template, {
        class: "modal-sm modal-dialog-centered",
      });
    }
  }

  decline() {
    this.isValid = false;
    this.modalRef.hide();
  }

  deleteConfirm() {
    this.deleteInquiry();
    this.modalRef.hide();
  }

  deleteInquiry() {
    this.spinner.show();
    this.UserService.UpdateInquiryStatus({
      InquiryId: this.deleteId,
      Status: this.delstatus,
    }).subscribe(
      (response: any) => {
        if (response["result"] == "success") {
          this.spinner.hide();
          this.toastr.success("Inquiry Deleted Successfully!");
          this.router
            .navigateByUrl("/RefreshComponent", { skipLocationChange: true })
            .then(() => {
              this.router.navigateByUrl("/inquiry/inquirylist");
            });
        } else {
          this.spinner.hide();
          this.toastr.error(response["Msg"]);
        }
      },
      (error) => {
        this.spinner.hide();
        this.toastr.error("Message");
      }
    );
  }

  rtnView() {
    this.router
      .navigateByUrl("/RefreshComponent", { skipLocationChange: true })
      .then(() => {
        this.router.navigateByUrl("/inquiry/inquirylist");
      });
  }
}
